import { IconWrapper, ItemContainer } from './CategorySlider.styles';
import type { ItemProps } from './types';

const SliderItem: React.FC<React.PropsWithChildren<ItemProps>> = ({
  text,
  icon,
  isSelected,
  handleClick,
}) => (
  <ItemContainer
    onClick={handleClick}
    isSelected={isSelected}
    className="flex flex-col items-center justify-center flex-shrink-0  px-8"
  >
    {icon && (
      <IconWrapper
        dangerouslySetInnerHTML={{
          // @ts-ignore
          __html: icon,
        }}
      />
    )}
    {text && (
      <span
        className="tw-font-pop text-12 font-semibold text-white leading-14 mt-2 sm:mt-4 text-center "
        css={`
          max-width: 90%;
        `}
      >
        {text}
      </span>
    )}
  </ItemContainer>
);

export default SliderItem;
